import React from "react";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

// Inline SVG icons
const Icons = {
  LayoutDashboard: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect width="7" height="9" x="3" y="3" rx="1"/><rect width="7" height="5" x="14" y="3" rx="1"/><rect width="7" height="9" x="14" y="12" rx="1"/><rect width="7" height="5" x="3" y="16" rx="1"/>
    </svg>
  ),
  Wallet: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"/><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"/>
    </svg>
  ),
  WalletSmall: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"/><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"/>
    </svg>
  ),
  Settings: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/>
    </svg>
  ),
  CheckCircle: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/>
    </svg>
  ),
  CheckCircleSmall: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/>
    </svg>
  ),
  Send: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"/><path d="m21.854 2.147-10.94 10.939"/>
    </svg>
  ),
  ArrowLeftRight: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 3 4 7l4 4"/><path d="M4 7h16"/><path d="m16 21 4-4-4-4"/><path d="M20 17H4"/>
    </svg>
  ),
  Receipt: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/><path d="M12 17.5v-11"/>
    </svg>
  ),
  ArrowRightLeft: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m16 3 4 4-4 4"/><path d="M20 7H4"/><path d="m8 21-4-4 4-4"/><path d="M4 17h16"/>
    </svg>
  ),
  Activity: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"/>
    </svg>
  ),
  Bell: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/>
    </svg>
  ),
  RefreshCw: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/>
    </svg>
  ),
  LogOut: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" x2="9" y1="12" y2="12"/>
    </svg>
  ),
  Building: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect width="16" height="20" x="4" y="2" rx="2" ry="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01"/><path d="M16 6h.01"/><path d="M12 6h.01"/><path d="M12 10h.01"/><path d="M12 14h.01"/><path d="M16 10h.01"/><path d="M16 14h.01"/><path d="M8 10h.01"/><path d="M8 14h.01"/>
    </svg>
  ),
  Users: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  History: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l4 2"/>
    </svg>
  ),
};

// Mock data
const MOCK_ACCOUNTS = [
  { id: 1, tipo: "Checking", numero: "****4521", saldo: 125340.50 },
  { id: 2, tipo: "Savings", numero: "****8732", saldo: 89200.00 },
  { id: 3, tipo: "Checking", numero: "****1156", saldo: 42150.75 },
];

export const CorporativoBusinessBankingLandingWeb = () => {
  const colors = useDynamicColors();

  const totalBalance = MOCK_ACCOUNTS.reduce((sum, acc) => sum + acc.saldo, 0);

  const formatAmount = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  };

  const quickActions = [
    { icon: Icons.Send, label: "Send Wire", color: colors.primario },
    { icon: Icons.ArrowLeftRight, label: "ACH Payment", color: colors.secundario },
    { icon: Icons.Receipt, label: "Pay Bill", color: colors.terciario },
    { icon: Icons.ArrowRightLeft, label: "Transfer", color: colors.septimo },
  ];

  const sidebarItems = [
    { icon: Icons.LayoutDashboard, label: "Dashboard", active: true },
    { icon: Icons.WalletSmall, label: "Accounts" },
    { icon: Icons.Settings, label: "Administration", children: [
      { icon: Icons.Building, label: "Company" },
      { icon: Icons.Users, label: "Users" },
    ]},
    { icon: Icons.CheckCircleSmall, label: "Approvals Center" },
    { icon: Icons.Send, label: "Wire Transfers", children: [
      { icon: Icons.History, label: "History" },
    ]},
    { icon: Icons.ArrowLeftRight, label: "ACH Payments", children: [
      { icon: Icons.History, label: "History" },
    ]},
    { icon: Icons.Receipt, label: "Bill Pay" },
    { icon: Icons.ArrowRightLeft, label: "Transfers" },
    { icon: Icons.Activity, label: "All Activity" },
  ];

  const laptop = {
    marginTop: "30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#333",
    borderRadius: "15px 15px 5px 5px",
    padding: "17px",
    width: "1400px",
    height: "800px",
    position: "relative",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  };

  const screen = {
    backgroundColor: "white",
    borderRadius: "5px",
    overflow: "hidden",
    width: "100%",
    height: "100%",
  };

  const base = {
    position: "absolute",
    width: "1600px",
    height: "20px",
    backgroundColor: "rgb(170, 170, 170)",
    borderRadius: "0px 0px 10px 10px",
    bottom: 0,
  };

  return (
    <div style={laptop}>
      <div style={screen}>
        <div className="bb-landing-screen">
          {/* Sidebar */}
          <div className="bb-landing-sidebar">
            <div className="bb-sidebar-logo">
              {colors.url_logo && (
                <img src={colors.url_logo} alt="Logo" />
              )}
            </div>
            <nav className="bb-sidebar-nav">
              {sidebarItems.map((item) => (
                <div key={item.label}>
                  <button
                    className={`bb-sidebar-item${item.active ? " active" : ""}`}
                    style={
                      item.active
                        ? { backgroundColor: `${colors.terciario}33`, color: colors.primario }
                        : undefined
                    }
                    type="button"
                  >
                    <item.icon />
                    <span>{item.label}</span>
                  </button>
                  {item.children &&
                    item.children.map((child) => (
                      <button key={child.label} className="bb-sidebar-subitem" type="button">
                        <child.icon />
                        <span>{child.label}</span>
                      </button>
                    ))}
                </div>
              ))}
            </nav>
          </div>

          {/* Main area */}
          <div className="bb-landing-main">
            {/* Header */}
            <div className="bb-landing-header">
              <div className="bb-header-bg" style={{ backgroundColor: colors.primario }} />
              <div className="bb-header-left">
                <span className="bb-header-company-name">Demo Company Inc.</span>
              </div>
              <div className="bb-header-right">
                <span className="bb-header-user">John Doe</span>
                <button className="bb-header-btn" type="button">
                  <Icons.Bell />
                </button>
                <button className="bb-header-btn" type="button">
                  <Icons.RefreshCw />
                </button>
                <button className="bb-header-btn" type="button">
                  <Icons.LogOut />
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="bb-landing-content">
              <div className="bb-landing-content-inner">
                {/* Welcome */}
                <div>
                  <h1 className="bb-welcome-title">Welcome</h1>
                  <p className="bb-welcome-subtitle">Demo Company Inc.</p>
                </div>

                {/* Cards row */}
                <div className="bb-cards-grid">
                  {/* Balance card */}
                  <div className="bb-card">
                    <div className="bb-balance-header">
                      <div
                        className="bb-balance-icon"
                        style={{ backgroundColor: `${colors.primario}15` }}
                      >
                        <Icons.Wallet style={{ color: colors.primario }} />
                      </div>
                      <div>
                        <p className="bb-balance-label">Total Balance</p>
                        <p className="bb-balance-amount">{formatAmount(totalBalance)}</p>
                      </div>
                    </div>
                    <div>
                      {MOCK_ACCOUNTS.map((acc) => (
                        <div key={acc.id} className="bb-account-row">
                          <span className="bb-account-name">
                            {acc.tipo} - {acc.numero}
                          </span>
                          <span className="bb-account-balance">
                            {formatAmount(acc.saldo)}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Approvals card */}
                  <div className="bb-card">
                    <div className="bb-approvals-status">
                      <span style={{ color: "#22c55e" }}>
                        <Icons.CheckCircle />
                      </span>
                      <div>
                        <p className="bb-approvals-title">All Clear</p>
                        <p className="bb-approvals-desc">No pending approvals</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Quick actions */}
                <div className="bb-card">
                  <h3 className="bb-card-title">Quick Actions</h3>
                  <div className="bb-quick-actions-grid">
                    {quickActions.map((action) => (
                      <button key={action.label} className="bb-quick-action" type="button">
                        <div
                          className="bb-quick-action-icon"
                          style={{ backgroundColor: `${action.color}15` }}
                        >
                          <span style={{ color: action.color }}>
                            <action.icon />
                          </span>
                        </div>
                        <span className="bb-quick-action-label">{action.label}</span>
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={base}></div>
    </div>
  );
};
